import React from "react";
import HeaderDrawer from "../../../common/components/HeaderDrawer";
import RegisterDepartment from "../../components/RegisterDepartment";

const RegisterDepartmentScreen = (props) => {
  return (
    <HeaderDrawer name="Cadastrar novo setor">
      <RegisterDepartment {...props} />
    </HeaderDrawer>
  );
};

export default RegisterDepartmentScreen;
